// store.js — kleiner Signal-Store (Node + Browser).
//   const n = signal(0); n.value++; effect(() => console.log(n.value));
//   const doppelt = computed(() => n.value * 2);
//   const theme = persist('vc-theme', { mode: 'system' });
// Effekte laufen synchron und sofort; Abhängigkeiten werden bei jedem Lauf neu erfasst.

let current = null;          // gerade laufender Effekt
let batchDepth = 0;
const pending = new Set();

function schedule(eff) {
  if (batchDepth > 0) { pending.add(eff); return; }
  eff.run();
}

export function batch(fn) {
  batchDepth++;
  try { return fn(); }
  finally {
    if (--batchDepth === 0) {
      const list = [...pending]; pending.clear();
      for (const e of list) if (!e.disposed) e.run();
    }
  }
}

export function signal(initial, { equals = Object.is } = {}) {
  let v = initial;
  const subs = new Set();
  return {
    get value() { if (current) { subs.add(current); current.deps.add(subs); } return v; },
    set value(next) {
      if (equals(v, next)) return;
      v = next;
      for (const e of [...subs]) schedule(e);
    },
    peek() { return v; },
    update(fn) { this.value = fn(v); },
    subscribe(fn) { return effect(() => fn(this.value)); },
  };
}

export function effect(fn) {
  const eff = {
    deps: new Set(), disposed: false, cleanup: null,
    run() {
      if (this.disposed) return;
      for (const d of this.deps) d.delete(this);
      this.deps.clear();
      if (typeof this.cleanup === 'function') { try { this.cleanup(); } catch {} }
      const prev = current; current = this;
      try { this.cleanup = fn(); } finally { current = prev; }
    },
  };
  eff.run();
  return () => {
    eff.disposed = true;
    for (const d of eff.deps) d.delete(eff);
    eff.deps.clear();
    if (typeof eff.cleanup === 'function') { try { eff.cleanup(); } catch {} }
  };
}

export function computed(fn) {
  const s = signal(undefined);
  effect(() => { s.value = fn(); });
  return { get value() { return s.value; }, peek: () => s.peek() };
}

/** Signal, das in localStorage gespiegelt wird. Fehler beim Lesen/Schreiben werden geschluckt. */
export function persist(key, initial, storage = (typeof localStorage !== 'undefined' ? localStorage : null)) {
  let start = initial;
  try {
    const raw = storage && storage.getItem(key);
    if (raw != null) start = JSON.parse(raw);
  } catch {}
  const s = signal(start);
  effect(() => {
    const v = s.value;
    try { storage && storage.setItem(key, JSON.stringify(v)); } catch {}
  });
  return s;
}
